import React from 'react';
import { Tier } from '../types/commission';
interface TierLadderProps {
  tiers: Tier[];
  currentTierLevel: number;
}
export function TierLadder({
  tiers,
  currentTierLevel
}: TierLadderProps) {
  const stepColumns = tiers[0].steps.slice(1);
  return <section aria-labelledby="ladder-heading" className="rounded-xl border border-slate-200 bg-white p-6 shadow-card" data-id="element-76" data-mp="urr7flc69qeg">
      <h2 id="ladder-heading" className="text-base font-bold text-slate-900" data-id="element-77" data-mp="1nihlg8pgkn0f">
        Compensation ladder
      </h2>
      <p className="mt-0.5 text-sm text-slate-500" data-id="element-78" data-mp="1iiwmvze7ago8">Total BPS paid per funded loan at each tier and unit level.</p>

      <div className="mt-5 overflow-x-auto" data-id="element-79" data-mp="1djk0ffr8rbm6">
        <table className="w-full min-w-[560px] text-sm" data-id="element-80" data-mp="1dmem1alzr2h6">
          <thead data-id="element-81" data-mp="19hoprknf7lvq">
            <tr className="border-b border-slate-200 text-xs font-semibold uppercase tracking-wider text-slate-500" data-id="element-82" data-mp="19i6tf2cex2do">
              <th scope="col" className="py-2 pr-4 text-left" data-id="element-83" data-mp="2322tcbwr2xy">
                Tier
              </th>
              <th scope="col" className="px-4 py-2 text-right" data-id="element-84" data-mp="3ub1zp197w259">
                Base
              </th>
              {stepColumns.map(step => <th key={step.units} scope="col" className="px-4 py-2 text-right" data-id="element-85" data-mp="3bf22bh86m077">
                  {step.units}+ units
                </th>)}
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100" data-id="element-86" data-mp="2xhvn1wmo2jmq">
            {tiers.map(tier => {
            const isCurrent = tier.level === currentTierLevel;
            return <tr key={tier.id} className={isCurrent ? 'bg-brand-50' : undefined} data-id="element-87" data-mp="2noy11gigucjd">
                  <th scope="row" className="py-3 pr-4 text-left font-semibold text-slate-900" data-id="element-88" data-mp="2sgpwo5ghb8gd">
                    <span className="flex items-center gap-2" data-id="element-89" data-mp="2dsbiiydm3xki">
                      <span className="text-xs font-bold tabular-nums text-slate-400" data-id="element-90" data-mp="2iqmr75s68215">{tier.level}</span>
                      {tier.name}
                      {isCurrent ? <span className="rounded-full bg-brand-700 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-white" data-id="element-91" data-mp="24s6ixaenu3gw">
                          You
                        </span> : null}
                    </span>
                  </th>
                  <td className="px-4 py-3 text-right tabular-nums text-slate-700" data-id="element-92" data-mp="aizyudbcm3x5">{tier.baseBps}</td>
                  {tier.steps.slice(1).map(step => <td key={step.units} className={`px-4 py-3 text-right tabular-nums ${isCurrent ? 'font-semibold text-slate-900' : 'text-slate-700'}`} data-id="element-93" data-mp="5kyhbwtkmcns">
                      {step.bps}
                    </td>)}
                </tr>;
          })}
          </tbody>
        </table>
      </div>
    </section>;
}